const nullBind = (fn, ...args) => fn.bind(null, ...args);

export default nullBind;
